/*
 * @Author: Wolf.Ma
 * @Date: 2023-04-06 15:35:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-05-23 17:18:37
 * @FilePath: /njoy-design/src/login/index.tsx
 * @Description:
 */
'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { ConfigProvider } from 'antd';
import React, { useState } from 'react';
import { antdTheme, njoydTheme } from "../theme";
import Forget from "./components/forget";
import LoginComponent from "./components/loginComponent";
import "./styles/login.less";
var Login = function Login(props) {
  var backgroundColor = props.backgroundColor,
    borderRadius = props.borderRadius,
    _props$loginPadding = props.loginPadding,
    loginPadding = _props$loginPadding === void 0 ? 10 : _props$loginPadding;
  var _useState = useState('login'),
    _useState2 = _slicedToArray(_useState, 2),
    loginType = _useState2[0],
    setLoginType = _useState2[1];
  // antd 原生主题对象
  var antd = antdTheme();
  // njoyd 原生主题对象
  var njoyd = njoydTheme();

  /**
   * 跳转类型
   */
  var jumpType = function jumpType(type) {
    setLoginType(type);
  };
  return /*#__PURE__*/React.createElement(ConfigProvider, {
    theme: {
      token: antd
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "njoy_login_content njoy_flex_row_center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "njoy_content_center njoy_flex_row_center",
    style: {
      backgroundColor: backgroundColor,
      borderRadius: borderRadius || njoyd.borderRadius,
      padding: loginPadding
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "njoy_right"
  }, loginType === 'login' && /*#__PURE__*/React.createElement(LoginComponent, _extends({}, props, {
    jumpType: jumpType
  })), loginType === 'forget' && /*#__PURE__*/React.createElement(Forget, _extends({}, props, {
    jumpType: jumpType
  }))))));
};
export default Login;